export const onelink = {
  click_to_copy: "Click to copy link",
  copied: "Copied!",

  show_onelink_list: "Show all",
  hide_onelink_list: "Hide",
  button_create_new_onelink: "Create new onelink",
  button_edit_onelink: "Edit onelink",
  button_delete_editor: "Close editor",
  button_upgrade_plan_template: "Upgrade To %s Plan",
  button_delete_onelink: "Delete Onelink",
  delete_onelink_warning_text:
    "When deleting your Onelink, it will stop working and you will lose access to statistics. This action is not reversible.",
  legacy_link_delete_info:
    "This is a legacy link. If you only have legacy links, you can have more than the Free plan limit.",
  upgrade_teaser: "Upgrade plan to create more onelinks",

  onelink_count_template_single: "You have %d onelink",
  onelink_count_template: "You have %d onelinks",
  onelink_account_limits_template: "%d included in the %s plan",
  onelink_list_template: "Showing %d-%d of %d",

  onelink_list_no_links:
    "You have no onelinks yet. Create your first onelink with the button above.",

  info_no_onelinks_head: "You have no onelinks",
  info_no_onelinks_desc:
    "Create your first onelink by clicking the button below.",

  name_default: "No name",

  download_svg: "Download QR as SVG image",
  download_png_small: "Download QR as PNG image - Small size",
  download_png_large: "Download QR as PNG image - Large size",

  button_show_account_stats_overview: "Show Statistics Overview",
  account_stats_overview_head: "Account Statistics Overview",
  account_stats_overview_info: "Aggregated statistics for all your onelinks",

  button_utm_campaign: "Create UTM campaign",
  button_utm_editor_close: "Done",
  button_utm_copy_link: "Copy UTM link",
  button_utm_clear: "Clear",
  button_utm_link_info:
    "Create a onelink / QR code with UTM campaign parameters",
  utm_campaign_heading: "Create UTM trackable onelink and QR code",

  utm_source: "source",
  utm_medium: "medium",
  utm_campaign: "campaign",
  utm_term: "term",
  utm_content: "content",
};
